import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';


export async function loginUser(email, password) {
  const res = await axios.post(`${API_URL}/auth/login`, { email, password }, { withCredentials: true });
  return res.data;
}


export async function registerUser(email, password, displayName) {
  const res = await axios.post(`${API_URL}/auth/register`, { email, password, display_name: displayName });
  return res.data;
}


export async function resetPassword(email) {
  const res = await axios.post(`${API_URL}/auth/reset-password`, { email });
  return res.data;
}



export async function getProfile() {
  const token = localStorage.getItem('token');
  const res = await axios.get(`${API_URL}/auth/me`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  });
  return res.data;
}


export async function logoutUser() {
  await axios.post(`${API_URL}/auth/logout`, {}, { withCredentials: true });
}
